import { apiURL } from "../../config";

export async function getUpperUnitList(axiosPrivate, unitId, phrase) {
	const phraseURL = phrase ? `?phrase=${phrase.replace(" ", "%20")}` : "";
	return axiosPrivate
		.get(`${apiURL}/organization-unit/available-parent/${unitId}.json${phraseURL}`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}
